<script lang="ts">
import Container from '@/components/base/layout/Container.vue';
import Header3 from '@/components/base/typography/Header3.vue';
import CustomizerRecommendationCard from '@/components/customizer/CustomizerRecommendationCard.vue';
import { SupportedCustomProductKey } from '@/lib/product';
import { BuilderComponent, CustomizerRecommendation } from '@/utils/cms';

export const CustomizerRecommendationsRowRegistration: BuilderComponent = {
  name: 'Customizer Recommendations Row',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'Recommended Combinations',
    },
    {
      name: 'type',
      type: 'string',
      enum: ['CSB', 'Custom Mix', 'Custom Tray'],
      defaultValue: 'Custom Tray',
      required: true,
    },
    {
      name: 'recommendations',
      type: 'list',
      subFields: [
        { name: 'name', type: 'string', required: true },
        {
          name: 'image',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'jpg', 'svg'],
          required: true,
        },
        { name: 'description', type: 'string', required: true },
        {
          name: 'code',
          type: 'string',
          required: true,
          helperText:
            'Encoded customizer selections for trays and mixes (i.e. 1QE0Li0rf16q1PW), or selections skus for CSB (i.e. 5455-01~5455-02~5455-03)',
        },
        { name: 'displayPrice', type: 'number' },
        { name: 'strikethroughPrice', type: 'number' },
        { name: 'sku', type: 'string' },
        {
          name: 'enableAddToCart',
          type: 'boolean',
          defaultValue: true,
        },

        { name: 'enableCustomizeButton', type: 'boolean', defaultValue: true },
      ],
      required: true,
    },
  ],
};
</script>

<script setup lang="ts">
const { title = 'Recommended Combinations' } = defineProps<{
  recommendations: CustomizerRecommendation[];
  title?: string;
  type: SupportedCustomProductKey;
}>();
</script>

<template>
  <Container class="wrapper-container" noMobilePadding>
    <Header3 headerTag="h2">{{ title }}</Header3>
    <div
      class="grid grid-flow-col auto-cols-[280px] gap-4 mt-6 overflow-x-auto max-w-full sm:grid-flow-row sm:auto-cols-auto sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 sm:justify-center sm:overflow-hidden slider-container"
    >
      <CustomizerRecommendationCard
        v-for="recommendation in recommendations"
        :key="recommendation.code"
        :recommendation
        :type
        class="snap-start"
      />
    </div>
  </Container>
</template>

<style lang="scss" scoped>
.wrapper-container {
  @media screen and (max-width: 639px) {
    @apply max-w-full;
  }
}

.slider-container {
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 639px) {
    scroll-snap-type: x mandatory;
  }
}
</style>
